export default __webpack_public_path__ + "static/media/app-icon.2c891c4e.png";